module.exports = __webpack_public_path__ + "img/erweima.203a7744.png";